import { checkResponse, get, post } from './http';

const BaseUrl = process.env.VUE_APP_API_EXTERNAL;

/*
    API
*/
export async function getAllTipoDocumentos() {
    return get(BaseUrl + 'Misc/getTiposDocumento')
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
        });
}

export async function getAllCondicionAfiliacion() {
    return get(BaseUrl + 'Misc/getCondicionAfiliacion')
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
        });
}

export async function getAllCondicionContacto() {
    return get(BaseUrl + 'Misc/getMotivosContacto')
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
        });
}


/*
    METHODS
*/
